if (!customElements.get("m-press-features")) {
  class MPressFeatures extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.enableSlider = this.dataset.enableSlider === "true";
      this.items = parseInt(this.dataset.items) || 4;
      this.showPagination = this.dataset.showPagination === "true";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.slideContainer = this.querySelector(".press-features__slider");
      this.paginationEl = this.querySelector(".press-features__pagination");
      this.prevButton = this.querySelector(".press-features__nav-prev");
      this.nextButton = this.querySelector(".press-features__nav-next");
      this.wrapper = this.querySelector(".swiper-wrapper");

      if (this.enableSlider) {
        this.initSlider();
      }
    }

    initSlider() {
      if (!this.slideContainer || !this.wrapper) return;

      const slideItemsLength = this.wrapper.childElementCount;
      const gap = parseInt(getComputedStyle(this).getPropertyValue("--card-gap")) || 24;
      const _this = this;

      // Load Swiper chunk dynamically (theme pattern)
      import(flu.chunks.swiper).then(({ Swiper, Navigation, Pagination }) => {
        const modules = [];
        const swiperOptions = {
          slidesPerView: 1.15,
          spaceBetween: 16,
          loop: slideItemsLength > _this.items,
          grabCursor: true,
          watchSlidesProgress: true,
          breakpoints: {
            480: {
              slidesPerView: 2,
              spaceBetween: 16,
            },
            768: {
              slidesPerView: Math.max(_this.items - 1, 2),
              spaceBetween: 20,
            },
            1280: {
              slidesPerView: _this.items,
              spaceBetween: gap,
            },
          },
        };

        if (_this.showPagination && _this.paginationEl) {
          modules.push(Pagination);
          swiperOptions.pagination = {
            el: _this.paginationEl,
            clickable: true,
          };
        }

        if (_this.showNavigation && _this.prevButton && _this.nextButton) {
          modules.push(Navigation);
          swiperOptions.navigation = {
            prevEl: _this.prevButton,
            nextEl: _this.nextButton,
          };
        }

        if (modules.length) {
          swiperOptions.modules = modules;
        }

        _this.slider = new Swiper(_this.slideContainer, swiperOptions);

        // Shopify editor block select
        document.addEventListener("shopify:block:select", (e) => {
          const block = e.target;
          const index = Number(block.dataset.slide);
          if (_this.slider && !isNaN(index)) {
            _this.slider.slideToLoop(index);
          }
        });
      }).catch((err) => {
        console.warn("Press features: Failed to load Swiper", err);
      });
    }
  }

  customElements.define("m-press-features", MPressFeatures);
}
